var _a, _ChatHistoryManager_DEFAULT_INDEX, _ChatHistoryManager_CAPACITY, _ChatHistoryManager_chatHistories, _ChatHistoryManager_index;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
export class ChatHistoryManager {
    constructor() {
        _ChatHistoryManager_chatHistories.set(this, void 0);
        _ChatHistoryManager_index.set(this, void 0);
        __classPrivateFieldSet(this, _ChatHistoryManager_chatHistories, [], "f");
        __classPrivateFieldSet(this, _ChatHistoryManager_index, __classPrivateFieldGet(_a, _a, "f", _ChatHistoryManager_DEFAULT_INDEX), "f");
    }
    addHistory(chat) {
        __classPrivateFieldGet(this, _ChatHistoryManager_chatHistories, "f").unshift(chat);
        __classPrivateFieldSet(this, _ChatHistoryManager_chatHistories, __classPrivateFieldGet(this, _ChatHistoryManager_chatHistories, "f").filter((_, i) => i < __classPrivateFieldGet(_a, _a, "f", _ChatHistoryManager_CAPACITY)), "f");
    }
    getPrev() {
        var _b;
        __classPrivateFieldSet(this, _ChatHistoryManager_index, (_b = __classPrivateFieldGet(this, _ChatHistoryManager_index, "f"), _b++, _b), "f");
        if (__classPrivateFieldGet(this, _ChatHistoryManager_index, "f") >= __classPrivateFieldGet(this, _ChatHistoryManager_chatHistories, "f").length) {
            __classPrivateFieldSet(this, _ChatHistoryManager_index, __classPrivateFieldGet(this, _ChatHistoryManager_chatHistories, "f").length - 1, "f");
            console.warn('oldest history');
        }
        return __classPrivateFieldGet(this, _ChatHistoryManager_chatHistories, "f")[__classPrivateFieldGet(this, _ChatHistoryManager_index, "f")];
    }
    getNext() {
        var _b;
        __classPrivateFieldSet(this, _ChatHistoryManager_index, (_b = __classPrivateFieldGet(this, _ChatHistoryManager_index, "f"), _b--, _b), "f");
        if (__classPrivateFieldGet(this, _ChatHistoryManager_index, "f") < 0) {
            __classPrivateFieldSet(this, _ChatHistoryManager_index, -1, "f");
            console.warn('latest history');
        }
        return __classPrivateFieldGet(this, _ChatHistoryManager_index, "f") >= 0 ? __classPrivateFieldGet(this, _ChatHistoryManager_chatHistories, "f")[__classPrivateFieldGet(this, _ChatHistoryManager_index, "f")] : '';
    }
    isEmpty() {
        return __classPrivateFieldGet(this, _ChatHistoryManager_chatHistories, "f").length === 0;
    }
    resetIndex() {
        __classPrivateFieldSet(this, _ChatHistoryManager_index, __classPrivateFieldGet(_a, _a, "f", _ChatHistoryManager_DEFAULT_INDEX), "f");
    }
}
_a = ChatHistoryManager, _ChatHistoryManager_chatHistories = new WeakMap(), _ChatHistoryManager_index = new WeakMap();
_ChatHistoryManager_DEFAULT_INDEX = { value: -1 };
_ChatHistoryManager_CAPACITY = { value: 10 };
